
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('@/components/layout/Footer'));
const LandingPageNavigation = dynamic(() => import('@/components/layout/LandingPageNavigation'));
const Seo = dynamic(() => import('@/components/Seo'));
const Testimonials = dynamic(() => import('@/components/Testimonials'), {
    ssr: false,
});
import PluginDownload from '@/components/PluginDownload';
import PluginHowItWorks from '@/components/PluginHowItWorks';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import { Product } from 'types';
import { getTeamProductsWithPrices } from '@/data/products';
import LogosCloud from '@/components/LogosCloud';
import PluginFeatures from '@/components/PluginFeatures';
interface Props {
    products: Product[];
}
const Templates = ({ products }: Props) => {
    const { t, lang } = useLocale('b2b');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      {/* <Banner /> */}
      <Seo templateTitle={t('Plugins')} image={`https://easy-peasy.ai/api/og-template?title=${t('Plugins')}&description=${t('Connect your bots and tools with plugins')}`} description={t('Connect your bots and tools with plugins. Boost productivity and innovation across your entire organization with our comprehensive AI tools.')}/>
      <div className='relative  bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative bg-white pb-8 dark:bg-slate-900 lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <div className='relative z-50 mb-8 lg:mb-12'>
                  <LandingPageNavigation />
                </div>
                <div className='relative overflow-hidden'>
                  <div className='mx-auto max-w-7xl'>
                    <div className='relative z-10 pt-14 lg:w-full lg:max-w-2xl'>
                      <svg className='absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform fill-white dark:fill-slate-900 lg:block' viewBox='0 0 100 100' preserveAspectRatio='none' aria-hidden='true'>
                        <polygon points='0,0 90,0 50,100 0,100'/>
                      </svg>

                      <div className='relative px-6 py-20 sm:py-28 lg:px-8 lg:py-32 lg:pr-0'>
                        <div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-xl'>
                          <div className='mb-4 w-fit rounded-full bg-indigo-500/10 px-3 py-1 text-sm font-semibold leading-6 tracking-wide text-primary-600 ring-1 ring-inset ring-indigo-500/20'>
                            {t('All-In-One AI Platform')}
                          </div>
                          <h1 className='bg-gradient-to-r pb-2 from-primary-600 to-pink-600 bg-clip-text text-4xl font-bold tracking-tight text-transparent sm:text-6xl'>
                            {t('Connect Your Bots & Tools with Plugins')}
                          </h1>
                          <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-400'>
                            {t('Download, integrate, and automate your favorite platforms like WordPress, Shopify, and more.')}
                          </p>
                          <div className='mt-10 flex items-center gap-x-6'>
                            <div>
                              <div className='rounded-md shadow'>
                                <Link href='/login' className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'>
                                  {t('Get started for free')}
                                </Link>
                              </div>
                            </div>
                            <div className='convert-13-v1 flex'>
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>
                            </div>
                            <p className='mx-auto max-w-lg text-sm  text-gray-500 lg:mx-0'>
                              <strong>2,182,705+</strong> {t('happy users')}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='hidden lg:absolute inset-y-0 right-0 w-1/2 bg-gray-50 dark:bg-slate-800/50 lg:block'>
                    <img className='h-full w-full object-cover' src='/images/plugins/Plugins_easy-peasy.ai.jpg' alt=''/>
                  </div>
                </div>
                <div className='relative z-10 mt-10 flex w-full justify-center gap-x-4 gap-y-2 text-center text-gray-500 dark:text-slate-400 lg:text-lg'>
                  <div>🚀 {t('Powered by best AI models')}</div>
                  <div>🌍 {t('Supports 40+ languages')}</div>
                  <div>💳 {t('No credit card required')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LogosCloud />
      <PluginFeatures />
      <PluginDownload />
      <PluginHowItWorks />
      <Testimonials />
      <Footer />
    </main>);
};
export default Templates;
// add static props
async function getStaticProps() {
    const products = await getTeamProductsWithPrices();
    return {
        props: {
            products,
        },
    };
}

    async function __Next_Translate__getStaticProps__1a0cbfb6590__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/plugins',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb6590__ as getStaticProps }
  